import { Agree, Container as Framework, Module, Slide as SlideBase } from 'components/pages/certifications/framework'
import Oops from 'components/pages/certifications/Oops'
import React from 'react'
import useDriverCert from 'components/pages/certifications/useDriverCert'
import { Container, Image as RuiImage, Loader, Spacer, Text } from 'roadie-ui'
import { TRAINING_CERTS } from 'util/constants'

import slide01Intro from 'images/overthethreshold/01-title-slide.png'
import slide02WhatThreshold from 'images/overthethreshold/02-what-are-threshold-gigs.png'
import slide03Home from 'images/overthethreshold/03-home.png'
import slide03MapMarker from 'images/overthethreshold/03-map-marker.png'
import slide03X from 'images/overthethreshold/03-x.png'
import slide04Dropoff from 'images/overthethreshold/04-dropoff-location.png'
import slide04Signature from 'images/overthethreshold/04-signature-required.png'
import slide05Delivery1 from 'images/overthethreshold/05-delivery-beforeandafter-1.png'
import slide05Delivery2 from 'images/overthethreshold/05-delivery-beforeandafter-2.png'
import slide05Delivery3 from 'images/overthethreshold/05-delivery-beforeandafter-3.png'
import bannerPass from 'images/overthethreshold/banner-pass.png'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const OverTheThresholdPage: React.FC = () => {
  const { t } = useLocalization()
  const driverCertResult = useDriverCert(TRAINING_CERTS.THRESHOLD.ELIGIBLE_CERT)

  if (driverCertResult.loading) {
    return (
      <RoadieOverTheThreshold>
        <Loader />
      </RoadieOverTheThreshold>
    )
  }

  if (!driverCertResult.hasDriverCert) {
    return (
      <RoadieOverTheThreshold>
        <Oops message={t('dweb_certifications_over_the_threshold_ineligible_message')} />
      </RoadieOverTheThreshold>
    )
  }

  return (
    <RoadieOverTheThreshold>
      <Module certification={TRAINING_CERTS.THRESHOLD.CERT}>
        <Slide>
          <Image src={slide01Intro} />
          <Spacer $height="3.2rem" />
          <Text.Overline $color="primary-base">
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_start_delivering_button" />
          </Text.Overline>
          <Spacer $height="0.4rem" />
          <Text.H4>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_gig_certification_title" />
          </Text.H4>
          <Spacer $height="0.8rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_intro_description" />
          </Text.Body2>
        </Slide>
        <Slide>
          <Title>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_what_gigs_title" />
          </Title>
          <Spacer $height="3.2rem" />
          <Image src={slide02WhatThreshold} />
          <Spacer $height="3.2rem" />
          <Text.Body2>
            <LocalizedRichText
              translationKey="dweb_certifications_over_the_threshold_what_gigs_body"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_over_the_threshold_first_room" />
                  </strong>
                ),
              }}
            />
          </Text.Body2>
        </Slide>
        <Slide>
          <Title>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_requirements_title" />
          </Title>
          <Spacer $height="3.2rem" />
          <QAItem image={slide03MapMarker}>
            <LocalizedText translationKey="dweb_certifications_ott_ask_dropoff_location" />
          </QAItem>
          <Spacer $height="3.2rem" />
          <QAItem image={slide03X}>
            <LocalizedRichText
              translationKey="dweb_certifications_over_the_threshold_first_area_boundary_rule"
              params={{
                strongText1: (
                  <strong>
                    <LocalizedText translationKey="dweb_certifications_over_the_threshold_not_permitted" />
                  </strong>
                ),
              }}
            />
          </QAItem>
          <Spacer $height="3.2rem" />
          <QAItem image={slide03Home}>
            <LocalizedText translationKey="dweb_certifications_ott_unload_without_assistance" />
          </QAItem>
        </Slide>
        <Slide>
          <Title>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_delivery_procedures_title" />
          </Title>
          <Spacer $height="3.2rem" />
          <Text.Subtitle1>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_signature" />
          </Text.Subtitle1>
          <Spacer $height="1.6rem" />
          <Image src={slide04Signature} />
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_signature_requirement" />
            <br />
            <br />
            <LocalizedText translationKey="dweb_certifications_ott_return_if_no_access" />
          </Text.Body2>
          <Spacer $height="3.2rem" />
          <Text.Subtitle1>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_dropoff_location" />
          </Text.Subtitle1>
          <Spacer $height="1.6rem" />
          <Image src={slide04Dropoff} />
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_ott_dropoff_location_notes" />
          </Text.Body2>
        </Slide>
        <Slide>
          <Title>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_delivery_procedures_title" />
          </Title>
          <Spacer $height="3.2rem" />
          <Text.Subtitle1>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_delivery_photo" />
          </Text.Subtitle1>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_ott_delivery_photo_required" />
          </Text.Body2>
          <Spacer $height="1.6rem" />
          <Image src={slide05Delivery1} />
          <Spacer $height="1.6rem" />
          <Image src={slide05Delivery2} />
          <Spacer $height="1.6rem" />
          <Image src={slide05Delivery3} />
        </Slide>
        <Slide>
          <Title>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_please_confirm" />
          </Title>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_ott_completion_acknowledgement" />
          </Text.Body2>
          <Spacer $height="1.6rem" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_inside_delivery_required" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_first_room_only" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_load_unload_without_assistance" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_signature_required" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_return_if_no_signature" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_professional_conduct" />
          <Agree toKey="dweb_certifications_over_the_threshold_agree_noncompliance_deactivation" />
        </Slide>
        <Slide>
          <Image src={bannerPass} />
          <Spacer $height="3.2rem" />
          <Title>
            <LocalizedText translationKey="dweb_certifications_mail_innovations_great_job" />
          </Title>
          <Spacer $height="1.6rem" />
          <Text.Body2>
            <LocalizedText translationKey="dweb_certifications_over_the_threshold_completion_message" />
          </Text.Body2>
        </Slide>
      </Module>
    </RoadieOverTheThreshold>
  )
}

const QAItem: React.FC<
  React.PropsWithChildren<{
    image: string
  }>
> = (props) => (
  <Container.Grid $gridTemplateColumns="7.2rem 1fr">
    <Image src={props.image} />
    <Container.Base $padding="0.8rem 1.6rem">
      <Text.Body2>{props.children}</Text.Body2>
    </Container.Base>
  </Container.Grid>
)

const Slide: React.FC<React.PropsWithChildren> = (props) => (
  <SlideBase>
    {props.children}
    <Spacer $height="3.2rem" />
  </SlideBase>
)

const Image: React.FC<{
  src: string
}> = (props) => <RuiImage $width="100%" src={props.src} />

const Title: React.FC<React.PropsWithChildren> = (props) => <Text.H5 $fontWeight="bold" {...props} />

const RoadieOverTheThreshold: React.FC<React.PropsWithChildren> = (props) => {
  const { t } = useLocalization()

  return (
    <Container.Base $color="neutral-black">
      <Framework title={t('dweb_certifications_over_the_threshold_title')} {...props} />
    </Container.Base>
  )
}

export default OverTheThresholdPage
